import React, { useContext, useState } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import PropTypes from 'prop-types';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';

import { COLORS } from '../../../Constant/COLORS';

import CardLayout from '../../../Components/CardLayout';
import IOSSwitch from '../../../Components/IOSSwitch';
import { TypoPoppins } from '../../../Components/Typo';

import { UpdateReviewActiveState } from '../../../Server/Mutation';

const ReviewCard = ({
  name,
  id,
  jobID,
  date,
  review,
  referenceId,
  isActive,
}) => {
  const { showToastMessage } = useContext(ToastContext);

  const [shouldShowInPage, setShouldShowInPage] = useState(isActive);

  async function handleChange(event) {
    const { checked } = event.target;

    setShouldShowInPage(checked);
    const query = UpdateReviewActiveState({ isActive: checked, id });
    const { errors } = await Axios(query);

    if (errors) {
      showToastMessage("We're sorry, we couldn't update the review status");
      setShouldShowInPage(prevState => !prevState);
      return undefined;
    }
  }

  return (
    <CardLayout>
      <Stack
        direction={{ md: 'row' }}
        gap={2}
        alignItems={{ md: 'center' }}
        flexWrap={{ xs: 'wrap-reverse', md: 'unset' }}
        mb={1}
      >
        <Typography variant='h5' color={COLORS.teal}>
          {name}
        </Typography>
        <TypoPoppins ml='auto'>
          Show in Page
          <IOSSwitch
            sx={{ ml: 2 }}
            disableFocusRipple
            disableRipple
            checked={shouldShowInPage}
            onChange={handleChange}
          />
        </TypoPoppins>
      </Stack>
      <Box
        display='grid'
        gridTemplateColumns='auto 1fr'
        rowGap={1}
        columnGap={2}
      >
        <TypoPoppins>Reference ID</TypoPoppins>
        <TypoPoppins fontWeight={500}>{referenceId}</TypoPoppins>

        <TypoPoppins>Job ID</TypoPoppins>
        <TypoPoppins fontWeight={500}>{jobID}</TypoPoppins>

        <TypoPoppins>Event Date</TypoPoppins>
        <TypoPoppins fontWeight={500}>{date}</TypoPoppins>

        <TypoPoppins>Review</TypoPoppins>
        <TypoPoppins fontWeight={500}>{review}</TypoPoppins>
      </Box>
    </CardLayout>
  );
};

ReviewCard.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  jobID: PropTypes.string,
  date: PropTypes.string,
  review: PropTypes.string,
  isActive: PropTypes.bool,
  referenceId: PropTypes.string,
};

export default ReviewCard;
